import React from "react";

import isIntuit from "Intuit/isIntuit";
import cloneElements from "Utils/cloneElements";

import AppearingElement from "Common/AppearingElement";
import Button from "Common/Button";
import { BackButton } from "Common/forms/buttons";
import { Row, Col } from "Common/Grid";
import Icon from "Common/Icon";

export default class AppearingForm extends React.Component {
  constructor(props) {
    super(props);
    const pages = [];

    if (props.children) {
      props.children.forEach((child) => {
        if (child) {
          pages.push({
            complete: false,
          });
        }
      });
    }

    this.state = {
      currentPage: props.currentPage || 0,
      pages,
    };
  }

  componentDidUpdate(_prevProps, prevState) {
    const { onPageChanged } = this.props;

    if (onPageChanged && this.state.currentPage !== prevState.currentPage) {
      onPageChanged(this.state.currentPage, prevState.currentPage);
    }
  }

  isLastPage = () => {
    const { currentPage, pages } = this.state;
    return currentPage === pages.length - 1;
  };

  handleBackButton = () => {
    const { onBackOutOfForm } = this.props;
    const { currentPage } = this.state;

    if (currentPage !== 0) {
      this.setState({
        currentPage: currentPage - 1,
      });
    } else if (onBackOutOfForm) onBackOutOfForm();
  };

  handleNextButton = () => {
    const { submit } = this.props;
    const { currentPage } = this.state;

    if (!this.isLastPage()) {
      this.setState({
        currentPage: currentPage + 1,
      });
    } else {
      submit();
    }
  };

  createCompleteChangedHandler = (index) => (complete) => {
    const { pages } = this.state;
    const newPages = [...pages];
    newPages[index].complete = complete;
    this.setState({
      pages: newPages,
    });
  };

  renderChildren = () => {
    const { children } = this.props;
    const { currentPage } = this.state;
    const clonedChildren = cloneElements(children, (_e, index) => ({
      key: index,
      show: currentPage === index,
      onCompleteChanged: this.createCompleteChangedHandler(index),
    }));
    return clonedChildren;
  };

  renderFooter = () => {
    const { submitting } = this.props;
    const { currentPage, pages } = this.state;
    const nextButtonText = this.isLastPage() ? "Submit" : "Next";
    return (
      <Row>
        <Col xs={6}>{currentPage != 0 && <BackButton fullWidth={isIntuit()} onClick={this.handleBackButton} />}</Col>
        <Col xs={6}>
          <Button size="medium" fullWidth onClick={this.handleNextButton} disabled={!pages[currentPage].complete}>
            {submitting ? (
              <span>
                <Icon icon="spinner" spin="pulse" mr={2} />
                Saving...
              </span>
            ) : (
              <span>{nextButtonText}</span>
            )}
          </Button>
        </Col>
      </Row>
    );
  };

  render() {
    return (
      <form>
        {this.renderChildren()}
        {this.renderFooter()}
      </form>
    );
  }
}
export class AppearingFormSection extends React.Component {
  render() {
    const { show, children, onCompleteChanged } = this.props;
    return (
      <AppearingElement show={show}>
        {cloneElements(children, {
          onCompleteChanged,
        })}
      </AppearingElement>
    );
  }
}
